import { Product, ProductPrice } from '~/Api/Product';

export default class PricedProduct<Item> {
	item: Item;

	product: Product;

	price: ProductPrice | null;

	constructor(item: Item, product: Product, price: ProductPrice | null) {
		this.item = item;
		this.product = product;
		this.price = price;
	}
}
